import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../../store/auth-context";
import "./SideListView.css";
import { FaUser } from "react-icons/fa";
import { IoLogOut } from "react-icons/io5";

const SideListView = (props) => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  // Sign out: end the session and go to sign-in (replacing this page in the history, as LoadingComponent does).
  // Ticket 12: the public Accessibility help page sits outside LoadingComponent, which used to do the "go to sign-in"
  // half for every page, so Sign out now does it itself.
  const signOut = () => {
    authCtx.logoutUser();
    navigate("/login", { replace: true });
  };
  return (
    <div className="side-list-container">
      {/* RCMC-09 (ticket 11): the navigation region, named "Main" (v1.2's was unnamed) */}
      <nav aria-label="Main">
        <ul className="mcd-menu">
          {props.children}
        </ul>  
        <div className="user-profile">
          <FaUser size={20} style={{color:"rgba(209, 213, 219, 1)"}} aria-hidden="true" focusable="false" />
          <div style={{display:"flex",flexDirection:"column",marginLeft:"10px",marginRight:"10px",flex:"1",overflow:"hidden"}}>
            <div style={{color:"rgba(209, 213, 219, 1)",fontSize:"1rem",fontWeight:"bold",textOverflow: "ellipsis",overflow: "hidden",whiteSpace: "nowrap"}}>
              {authCtx.user.name}
            </div>
            {/* RCMC-20 (ticket 15): the account identifier in a lighter grey that holds 4.71:1 on the profile block
                (v1.2 #8392a5, 3.46:1) */}
            <div style={{fontSize:"0.7rem",color:"var(--portal-profile-id)"}}>
              {authCtx.user.pan_no}
            </div>
          </div>
          {/* RCMC-19 (ticket 11): Sign out is a native button named "Sign out" (v1.2: a bare, unnamed icon outside the
              Tab order). Same icon, same place; its 24×24 target is in SideListView.css. What it does is unchanged. */}
          <button type="button" className="logout-button" onClick={signOut}>
            <IoLogOut size={20} style={{color:"rgba(209, 213, 219, 1)"}} aria-hidden="true" focusable="false" />
            <span className="visually-hidden">Sign out</span>
          </button>
        </div>
      </nav>
    </div>
    // <div className="side-list-container">
    //   <nav>
    //     <ul className="mcd-menu">
    //       
          //  <li>
          //   <a href="xyz">
          //     <i className="fa fa-gift"></i>
          //     <strong>Features</strong>
          //     <small>sweet home</small>
          //   </a>
          // </li>
          // <li>
          //   <a href="xyz">
          //     <i className="fa fa-globe"></i>
          //     <strong>News</strong>
          //     <small>sweet home</small>
          //   </a>
          // </li>
          // <li>
          //   <a href="xyz">
          //     <i className="fa fa-comments-o"></i>
          //     <strong>Blog</strong>
          //     <small>what they say</small>
          //   </a>
          //   <ul>
          //     <li>
          //       <a href="xyz">
          //         <i className="fa fa-globe"></i>Mission
          //       </a>
          //     </li>
          //     <li>
          //       <a href="xyz">
          //         <i className="fa fa-group"></i>Our Team
          //       </a>
          //       <ul>
          //         <li>
          //           <a href="xyz">
          //             <i className="fa fa-female"></i>Leyla Sparks
          //           </a>
          //         </li>
          //         <li>
          //           <a href="xyz">
          //             <i className="fa fa-male"></i>Gleb Ismailov
          //           </a>
          //           <ul>
          //             <li>
          //               <a href="xyz">
          //                 <i className="fa fa-leaf"></i>About
          //               </a>
          //             </li>
          //             <li>
          //               <a href="xyz">
          //                 <i className="fa fa-tasks"></i>Skills
          //               </a>
          //             </li>
          //           </ul>
          //         </li>
          //         <li>
          //           <a href="xyz">
          //             <i className="fa fa-female"></i>Viktoria Gibbers
          //           </a>
          //         </li>
          //       </ul>
          //     </li>
          //     <li>
          //       <a href="xyz">
          //         <i className="fa fa-trophy"></i>Rewards
          //       </a>
          //     </li>
          //     <li>
          //       <a href="xyz">
          //         <i className="fa fa-certificate"></i>Certificates
          //       </a>
          //     </li>
          //   </ul>
          // </li>
          // <li>
          //   <a href="xyz">
          //     <i className="fa fa-picture-o"></i>
          //     <strong>Portfolio</strong>
          //     <small>sweet home</small>
          //   </a>
          // </li>
          // <li>
          //   <a href="xyz">
          //     <i className="fa fa-envelope-o"></i>
          //     <strong>Contacts</strong>
          //     <small>drop a line</small>
          //   </a>
          // </li>
          // <li>
          //   <a href="xyz">
          //     <i className="fa fa-envelope-o"></i>
          //     <strong>Contacts</strong>
          //     <small>drop a line</small>
          //   </a>
          // </li>
          // <li>
          //   <a href="xyz">
          //     <i className="fa fa-envelope-o"></i>
          //     <strong>Contacts</strong>
          //     <small>drop a line</small>
          //   </a>
          // </li>
          // <li>
          //   <a href="xyz">
          //     <i className="fa fa-envelope-o"></i>
          //     <strong>Contacts</strong>
          //     <small>drop a line</small>
          //   </a>
          // </li>
          // <li>
          //   <a href="xyz">
          //     <i className="fa fa-envelope-o"></i>
          //     <strong>Contacts</strong>
          //     <small>drop a line</small>
          //   </a>
          // </li>
          // <li>
          //   <a href="xyz">
          //     <i className="fa fa-envelope-o"></i>
          //     <strong>Contacts</strong>
          //     <small>drop a line</small>
          //   </a>
          // </li>
    //     </ul>
    //     <div className="user-profile">
          
    //     </div>
    //   </nav>
    // </div>
  );
};

export default SideListView;
